<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.28314 7.01315C9.28314 6.59894 9.61893 6.26315 10.0331 6.26315H16.5331C16.9474 6.26315 17.2831 6.59894 17.2831 7.01315C17.2831 7.42736 16.9474 7.76315 16.5331 7.76315H10.0331C9.61893 7.76315 9.28314 7.42736 9.28314 7.01315Z"
      fill="currentColor"
    />
    <path
      d="M9.28314 14.0132C9.28314 13.5989 9.61893 13.2632 10.0331 13.2632H16.5331C16.9474 13.2632 17.2831 13.5989 17.2831 14.0132C17.2831 14.4274 16.9474 14.7632 16.5331 14.7632H10.0331C9.61893 14.7632 9.28314 14.4274 9.28314 14.0132Z"
      fill="currentColor"
    />
    <path
      d="M5.75509 3.42224V8.51315H4.67874V3.42224H5.75509Z"
      fill="currentColor"
    />
    <path
      d="M7.26459 8.57778C7.10053 8.57778 6.95967 8.51978 6.842 8.40378C6.726 8.28611 6.668 8.14525 6.668 7.98119C6.668 7.81878 6.726 7.67958 6.842 7.56358C6.95967 7.44757 7.10053 7.38957 7.26459 7.38957C7.42368 7.38957 7.56289 7.44757 7.6822 7.56358C7.80152 7.67958 7.86118 7.81878 7.86118 7.98119C7.86118 8.09057 7.83301 8.19083 7.77666 8.28197C7.72198 8.37146 7.64989 8.44355 7.5604 8.49824C7.47091 8.55127 7.37231 8.57778 7.26459 8.57778Z"
      fill="currentColor"
    />
    <path
      d="M3.79318 11.4222V16.5132H2.71683V11.4222H3.79318Z"
      fill="currentColor"
    />
    <path
      d="M5.75509 11.4222V16.5132H4.67874V11.4222H5.75509Z"
      fill="currentColor"
    />
    <path
      d="M7.26459 16.5778C7.10053 16.5778 6.95967 16.5198 6.842 16.4038C6.726 16.2861 6.668 16.1453 6.668 15.9812C6.668 15.8188 6.726 15.6796 6.842 15.5636C6.95967 15.4476 7.10053 15.3896 7.26459 15.3896C7.42368 15.3896 7.56289 15.4476 7.6822 15.5636C7.80152 15.6796 7.86118 15.8188 7.86118 15.9812C7.86118 16.0906 7.83301 16.1908 7.77666 16.282C7.72198 16.3715 7.64989 16.4435 7.5604 16.4982C7.47091 16.5513 7.37231 16.5778 7.26459 16.5778Z"
      fill="currentColor"
    />
  </svg>
</template>
